<div class="flex flex-auto w-full min-w-80 h-50 p-4">
  <div class="flex flex-col flex-auto p-6 pb-4 bg-card shadow-md rounded overflow-hidden">
    <div class="flex items-center justify-between">
      <div class="flex flex-col">
        <div class="text-sm text-hint font-medium">{{ attributeLabel }}</div>
      </div>
    </div>
    <div class="mt-auto mb-2 font-semibold text-5xl tracking-tighter leading-none text-center">
      {{ attributeValue }}
    </div>
  </div>
</div>
